import { render, staticRenderFns } from "./SingleData.vue?vue&type=template&id=3dfc0260&scoped=true&"
import script from "./SingleData.vue?vue&type=script&lang=js&"
export * from "./SingleData.vue?vue&type=script&lang=js&"
import style0 from "./SingleData.vue?vue&type=style&index=0&id=3dfc0260&scoped=scoped&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dfc0260",
  null
  
)

export default component.exports